export const TAG_DEPTH = 'depth-';
export const GROUP_DEPTH = 'group-';
export const S5_ROW = 's5-row-';
export const S5_ROW_COUNTER = 's5-count-';
export const FAUX_CELL = 'faux-cell';
export const IS_LEAF = 's5-leaf-cell';
export const IS_PARENT = 's5-parent-cell';
export const CHILDREN_HIDDEN = 's5-children-hidden';
